var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhoneHandset = function SvgPhoneHandset(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26.678 26.678"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h26.678v26.678H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.371 19.363a2.333 2.333 0 0 1-1.663 1.6 4.324 4.324 0 0 1-1.6.306c-3.091.451-10.412-2.74-12.295-10.656a5.661 5.661 0 0 1 .125-3.7 2.392 2.392 0 0 1 2.329-1.62h.135c.685-.034.671-.024.923.6.442 1.1.909 2.186 1.364 3.279.063.151.1.312.175.459a.562.562 0 0 1-.111.659c-.377.433-.75.871-1.148 1.284a.365.365 0 0 0-.083.513c.38.561.764 1.12 1.162 1.669a14.448 14.448 0 0 0 3.49 3.219 5.453 5.453 0 0 0 .6.35.338.338 0 0 0 .436-.082c.422-.4.86-.785 1.3-1.167a.576.576 0 0 1 .655-.12c.994.42 1.993.83 2.992 1.239.365.149.739.274 1.1.43a.41.41 0 0 1 .219.237 3.354 3.354 0 0 1-.1 1.5M13.339 0a13.339 13.339 0 1 0 13.339 13.339A13.339 13.339 0 0 0 13.339 0"
  }))));
};
export default SvgPhoneHandset;